import React from "react";
import { PermissionProvider } from "@/contexts/PermissionContext";
import { useRecoverableProtectedAuth } from "@/hooks/useRecoverableProtectedAuth";

interface PermissionWrapperProps {
    children: React.ReactNode;
}

/**
 * Wrapper component that provides permission context to authenticated users
 */
export const PermissionWrapper: React.FC<PermissionWrapperProps> = ({
    children,
}) => {
    const { currentUser, isAuthenticated } = useRecoverableProtectedAuth();

    // Get userId from the appropriate profile
    const userId = React.useMemo(() => {
        if (!isAuthenticated || !currentUser) {
            return null;
        }

        return currentUser.userId;
    }, [currentUser, isAuthenticated]);

    return <PermissionProvider userId={userId}>{children}</PermissionProvider>;
};
